import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/Inter-latin.woff2%22,%22weight%22:%22400%22},{%22path%22:%22./fonts/Inter-latin.woff2%22,%22weight%22:%22500%22},{%22path%22:%22./fonts/Inter-latin.woff2%22,%22weight%22:%22600%22},{%22path%22:%22./fonts/Inter-latin.woff2%22,%22weight%22:%22700%22}],%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:true,%22adjustFontFallback%22:false,%22fallback%22:[%22InterFont%20Fallback%22],%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22InterFont%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0000-00FF,%20U+0131,%20U+0152-0153,%20U+02BB-02BC,%20U+02C6,%20U+02DA,%20U+02DC,%20%20%20%20%20%20%20%20U+0304,%20U+0308,%20U+0329,%20U+2000-206F,%20U+20AC,%20U+2122,%20U+2191,%20U+2193,%20U+2212,%20U+2215,%20U+FEFF,%20U+FFFD%22}]}],%22variableName%22:%22InterFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'InterFont', InterFont Fallback",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
